import { apiClient } from "../config";

async function getQAProgress(queryParams: any) {
  const res = await apiClient.get(`/admin/dashboard/widget/qa-progress`, {
    params: queryParams,
  });
  return res.data;
}

export default getQAProgress;
